<template>
  <div class="approval-config-filter">
    <b-row class="mb-5">
      <b-col md="3">
        <b-form-input
          v-model="filterData.name"
          type="text"
          placeholder="Tên cấu hình"
          size="sm"
          v-on:keyup.enter="applyFilter"
        ></b-form-input>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="filterData.type"
          :options="typeOptions"
          value-field="id"
          text-field="name"
          class="select-style"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="filterData.status"
          :options="statusOptions"
          value-field="id"
          text-field="name"
          class="select-style"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col md="1">
        <b-button
          class="filter-button"
          variant="primary"
          size="sm"
          @click="applyFilter"
        >
          Lọc
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ApprovalConfigFilter',
  props: {
    /**
     * List of approval types
     */
    typeOptions: {
      type: Array,
      required: true
    },
    /**
     * List of status options
     */
    statusOptions: {
      type: Array,
      required: true
    },
    /**
     * Initial filter values
     */
    initialFilter: {
      type: Object,
      default: () => ({
        name: '',
        type: null,
        status: null
      })
    }
  },
  data() {
    return {
      filterData: {
        name: this.initialFilter.name || '',
        type: this.initialFilter.type || null,
        status: this.initialFilter.status || null
      }
    };
  },
  methods: {
    /**
     * Apply the filter and emit the filter event
     */
    applyFilter() {
      this.$emit('filter', { ...this.filterData });
    },
    /**
     * Reset the filter to initial values
     */
    resetFilter() {
      this.filterData = {
        name: '',
        type: null,
        status: null
      };
      this.applyFilter();
    }
  },
  watch: {
    // Update local filter data when props change
    initialFilter: {
      handler(newVal) {
        this.filterData = { ...newVal };
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-config-filter {
  .filter-button {
    font-weight: 600;
    width: 70px;
  }
  
  .select-style {
    width: 100%;
  }
}
</style>
